import { useState, useEffect } from 'react';
import config from '../config';


export const ProductFilters = ({ filters = {}, onChange }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Local state برای مقادیر فیلترها
  const [localFilters, setLocalFilters] = useState({
    category: filters?.category || '',
    min_price: filters?.min_price || '',
    max_price: filters?.max_price || '',
    search: filters?.search || '',
  });

  useEffect(() => {
    // بارگذاری دسته‌بندی‌ها از API
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const response = await fetch(config.getApiUrl('/products/categories/'));
        const data = await response.json();
        // بررسی ساختار پاسخ - اگر آرایه است مستقیم استفاده کن، اگر داخل data است از آن استفاده کن
        const categoriesArray = Array.isArray(data) ? data : (data.results || data.data || []);
        setCategories(categoriesArray);
        console.log('Categories loaded:', categoriesArray); // برای دیباگ
      } catch (error) {
        console.error('Error loading categories:', error);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    // بروزرسانی local filters وقتی props تغییر می‌کند
    setLocalFilters({
      category: filters?.category || '',
      min_price: filters?.min_price || '',
      max_price: filters?.max_price || '',
      search: filters?.search || '',
    });
  }, [filters]);

  const handleFilterChange = (key, value) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
    
    // ارسال به parent
    if (onChange && typeof onChange === 'function') {
      onChange({ [key]: value });
    }
  };

  const handlePriceRangeChange = () => {
    if (onChange && typeof onChange === 'function') {
      onChange({
        min_price: localFilters.min_price,
        max_price: localFilters.max_price,
      });
    }
  };

  const handleSearchSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (onChange && typeof onChange === 'function') {
      onChange({ search: localFilters.search });
    }
  };

  const resetFilters = () => {
    setLocalFilters({
      category: '',
      min_price: '',
      max_price: '',
      search: '',
    });
    if (onChange && typeof onChange === 'function') {
      onChange({
        category: '',
        min_price: '',
        max_price: '',
        search: '',
      });
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-bold text-gray-900">فیلترها</h3>
        <button
          onClick={resetFilters}
          className="text-sm text-blue-600 hover:text-blue-700"
        >
          حذف همه
        </button>
      </div>

      {/* جستجو */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          جستجو
        </label>
        <form onSubmit={handleSearchSubmit}>
          <input
            type="text"
            value={localFilters.search}
            onChange={(e) => setLocalFilters({ ...localFilters, search: e.target.value })}
            onBlur={() => handleSearchSubmit()}
            placeholder="نام محصول..."
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </form>
      </div>

      {/* دسته‌بندی */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          دسته‌بندی
        </label>
        <select
          value={localFilters.category}
          onChange={(e) => handleFilterChange('category', e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
        >
          <option value="">همه دسته‌ها</option>
          {loading ? (
            <option disabled>در حال بارگذاری...</option>
          ) : (
            Array.isArray(categories) && categories.map((category) => (
              <option key={category.id} value={category.slug}>
                {category.name}
              </option>
            ))
          )}
        </select>
      </div>

      {/* محدوده قیمت */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          محدوده قیمت (تومان)
        </label>
        <div className="flex gap-2">
          <input
            type="number"
            value={localFilters.min_price}
            onChange={(e) => setLocalFilters({ ...localFilters, min_price: e.target.value })}
            onBlur={handlePriceRangeChange}
            placeholder="از"
            className="w-1/2 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="number"
            value={localFilters.max_price}
            onChange={(e) => setLocalFilters({ ...localFilters, max_price: e.target.value })}
            onBlur={handlePriceRangeChange}
            placeholder="تا"
            className="w-1/2 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* نمایش فیلترهای فعال */}
      {(localFilters.category || localFilters.min_price || localFilters.max_price || localFilters.search) && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <h4 className="text-sm font-medium text-gray-700 mb-2">فیلترهای فعال:</h4>
          <div className="flex flex-wrap gap-2">
            {localFilters.category && (
              <span className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-blue-100 text-blue-700">
                دسته: {categories.find(c => c.slug === localFilters.category)?.name || localFilters.category}
                <button
                  onClick={() => handleFilterChange('category', '')}
                  className="mr-1 hover:text-blue-900"
                >
                  ×
                </button>
              </span>
            )}
            {(localFilters.min_price || localFilters.max_price) && (
              <span className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-blue-100 text-blue-700">
                قیمت: {localFilters.min_price || '0'} - {localFilters.max_price || '∞'} تومان
                <button
                  onClick={() => {
                    setLocalFilters({ ...localFilters, min_price: '', max_price: '' });
                    if (onChange) onChange({ min_price: '', max_price: '' });
                  }}
                  className="mr-1 hover:text-blue-900"
                >
                  ×
                </button>
              </span>
            )}
            {localFilters.search && (
              <span className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-blue-100 text-blue-700">
                جستجو: {localFilters.search}
                <button
                  onClick={() => {
                    setLocalFilters({ ...localFilters, search: '' });
                    if (onChange) onChange({ search: '' });
                  }}
                  className="mr-1 hover:text-blue-900"
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};